import React, { useContext } from "react";
import "./Works.css";
import Upwork from "../../img/Upwork.png";
import Fiverr from "../../img/fiverr.png";
import whatsup from "../../img/whatsapp.png";
import discord from "../../img/discord.png";
import Facebook from "../../img/Facebook.png";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import {Link} from 'react-scroll'

const Works = () => {
  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  const openWhatsApp = () => {
    const businessNumber = '+923060831393'; // Replace with your WhatsApp Business number
    const messageTemplate = encodeURIComponent(
      "Hello Adnan, I'm interested in your development services. Can you provide more information?"
    );
    const whatsappUrl = `https://wa.me/${businessNumber}?text=${messageTemplate}`;
    window.open(whatsappUrl, '_blank');
  };
  // transition
  return (
    <div className="works" id="works">
      {/* left side */}
      <div className="w-left">
        <div className="awesome">
          {/* dark Mode */}
          <span style={{ color: darkMode ? "white" : "" }}>
            Works for All these
          </span>
          <span>Brands & Clients</span>
          <spane style={{ display: "block", lineHeight: "1.5", marginBottom: "10px" }}>
          Find Me Across Platforms 🌐
          <br />
Connect with me on a variety of platforms to explore  <br />my services and collaborate on exciting projects:
            <br />
             Facebook: Stay updated and connect on Facebook.
            <br />
 Discord: Join the conversation on Discord for real-time interactions.
<br />
Fiverr: Discover a range of services offered on Fiverr.
<br />
Upwork: Explore professional collaborations on Upwork.
<br />
WhatsApp: Reach out quickly via WhatsApp.
            <br />
            Wherever you prefer, I'm ready to assist and provide top-notch services!
          </spane>


          <Link to="contact" smooth={true} spy={true}>
            <button className="button s-button">Hire Me</button>
          </Link>
          <div
            className="blur s-blur1"
            style={{ background: "#ABF1FF94" }}
          ></div>
        </div>

        {/* right side */}
      </div>
      <div className="w-right">
        <motion.div
          initial={{ rotate: 45 }}
          whileInView={{ rotate: 0 }}
          viewport={{ margin: "-40px" }}
          transition={{ duration: 3.5, type: "spring" }}
          className="w-mainCircle"
        >
          <div className="w-secCircle">
            <img src={Upwork} alt="" onClick={() => window.open('https://www.upwork.com/freelancers/~0135e41b72f2a07724', '_blank')}/>
          </div>
          <div className="w-secCircle">
            <img src={Fiverr} alt="" onClick={() => window.open('https://www.fiverr.com/adnansudozai', '_blank')}/>
          </div>
          <div className="w-secCircle">
            <img src={whatsup} alt="" onClick={() => openWhatsApp()}/>
          </div>{" "}
          <div className="w-secCircle">
            <img src={discord} alt=""  onClick={() => window.open('https://discordapp.com/users/adnansaleem', '_blank')}/>
          </div>
          <div className="w-secCircle">
            <img src={Facebook} alt=""  onClick={() => window.open('https://www.facebook.com/profile.php?id=100079652867617&mibextid=ZbWKwL', '_blank')} />
          </div>
        </motion.div>
        {/* background Circles */}
        <div className="w-backCircle blueCircle"></div>
        <div className="w-backCircle yellowCircle"></div>
      </div>
    </div>
  );
};

export default Works;
